import api from './api';

const BASE_URL = '/consents';

const purposes = type => api.get(`${BASE_URL}/purposes`, { params: { type } });

export default {
  purposes,
};
